// TODO: gate on a backend Resource once the reports domain is defined.
export const reportsLoader = () => null;
